<script lang="ts">
  const { children } = $props();
</script>

<div>
  {@render children()}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  div {
    text-transform: uppercase;
    font: tokens.$oc-semantic-font-copy-75;
    margin-top: tokens.$oc-semantic-spacing-50;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>
